import React, { useState } from "react";
import { Modal, Spin, Tooltip } from "antd";
import AudioService from "../../../Services/AudioService";
import { MdSummarize } from "react-icons/md";

const Summary = ({ record }) => {
    const [loading, setLoading] = useState(false);
    const [showResultModal, setShowResultModal] = useState(false);
    const [transcript, setTranscript] = useState("");
    const [summary, setSummary] = useState("");

    // ✅ Fetch transcript & open modal
    const fetchTranscript = async () => {
        try {
            setLoading(true);

            const payload = {
                patientId: record.patientId,
                userId: record.userId,
                appointmentId: record.appointmentId,
            };

            console.log("📡 Fetching transcript with:", payload);
            const res = await AudioService.GetTranscriptStatus(payload);

            const transcriptData = res.data[0];
            console.log("✅ Transcript fetched:", transcriptData);

            setTranscript(
                transcriptData?.TRANSCRIPT || "Transcription not available."
            );
            setSummary(transcriptData?.SUMMARY || "Summary not available.");

            setShowResultModal(true);
        } catch (error) {
            console.error("❌ Failed to fetch transcript:", error);
            alert("Failed to fetch transcript details.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {/* 🟢 Button to view summary */}
            <Tooltip
            placement="top"
            title={"View Summary"} >
                <button
                    onClick={fetchTranscript}
                    className="w-8 h-8 rounded-full bg-[#DEF3F2] text-[#21a2ac] flex items-center justify-center cursor-pointer"
                >
                    <MdSummarize />
                </button>
            </Tooltip>
            {/* 🪄 Transcript Modal */}
            <Modal
                title="Consultation Summary"
                open={showResultModal}
                onCancel={() => setShowResultModal(false)}
                footer={null}
                centered
            >
                {loading ? (
                    <div className="flex justify-center items-center py-6">
                        <Spin size="large" />
                    </div>
                ) : (
                    <div className="space-y-4">
                        {/* <div>
                            <h3 className="font-semibold text-gray-800">🗣 Transcript</h3>
                            <p className="text-gray-700 whitespace-pre-line border p-2 rounded bg-gray-50">
                                {transcript}
                            </p>
                        </div> */}
                        <div>
                            <h3 className="font-semibold text-gray-800"> Summary</h3>
                            <p className="text-gray-700 border p-2 rounded bg-gray-50">
                                {summary}
                            </p>
                        </div>
                    </div>
                )}
            </Modal>
        </>
    );
};

export default Summary;
